import {ChangeDetectionStrategy, Component, input} from "@angular/core";
import {TranslateModule} from "@ngx-translate/core";
import {BankIdSigneringStatus} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {MatProgressBar} from "@angular/material/progress-bar";
import {TipsKomponent} from "web-ng2/delt/komponenter/tips/tips";
import {NgTemplateOutlet} from "@angular/common";
import {BankidKlientFeil} from "web-ng2/moduler/signering/tjenester/signering-bankid-qes-service";

/**
 * Dum komponent som viser løpende status for BankID-signering.
 * Mottar signeringsstatus som input og avhenger ikke av noen tjeneste.
 */
@Component({
    selector: 'signering-bankid-status',
    templateUrl: 'signering-bankid-status.html',
    imports: [
        TranslateModule,
        MatProgressBar,
        TipsKomponent,
        NgTemplateOutlet
    ],
    styleUrl: 'signering-bankid-status.scss',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SigneringBankidStatus {
    signeringStatus = input.required<BankIdSigneringStatus | BankidKlientFeil | null>();
    dokumentnavn = input<string | null>();
    protected readonly BankidKlientFeil = BankidKlientFeil;
    protected readonly BankIdSigneringStatus = BankIdSigneringStatus;
}
